import React from 'react';
import { Button } from 'antd';
import { Modal } from 'antd';

type BEOverwriteModalProps = {
  show: boolean;
  setShow: (flag: boolean) => void;
};

const BEOverwriteModal = ({
  show,
  setShow
}: BEOverwriteModalProps): JSX.Element => {
  const UpdateSavedRowHandler = (): void => {
    window.beeSaveResolver(window.beeHandleMetadata);
    setShow(false);
  };

  return (
    <Modal
      key="update_save_row"
      title="Overwrite Existing Component"
      style={{ top: '20vh' }}
      open={show}
      footer={[
        <Button
          key="Continue"
          type="primary"
          htmlType="submit"
          onClick={(): void => {
            UpdateSavedRowHandler();
          }}
        >
          Continue
        </Button>
      ]}
      onCancel={(): void => {
        window.beeSaveRejector();
        setShow(false);
      }}
    >
      <p>
        {[
          'You are updating an existing component. This will update the component in all the templates it has been used in.'
        ]}
      </p>
    </Modal>
  );
};

export default BEOverwriteModal;
